function r(t) {
  return (d = {}) => {
    const n = d.width ? String(d.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
export {
  r as buildFormatLongFn
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/locale/_lib/buildFormatLongFn.js
// module id = 890
// module chunks = 67